/* Background video for the hero.

   Deliberately conservative about when it loads. The poster image is already
   on the page and looks finished on its own, so the video is an enhancement:
   we skip it when the visitor has asked for reduced motion, when the screen is
   phone-sized (autoplay is unreliable there and it is a lot of data on mobile),
   and when the connection reports itself as slow or on a data saver. */

(function () {
  'use strict';

  var MIN_WIDTH = 750;

  function shouldLoad() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    if (window.innerWidth < MIN_WIDTH) return false;

    var conn = navigator.connection;
    if (conn) {
      if (conn.saveData) return false;
      if (/2g/.test(conn.effectiveType || '')) return false;
    }
    return true;
  }

  function build(holder) {
    var id = holder.getAttribute('data-yt');
    if (!id || holder.querySelector('iframe')) return;

    var params = [
      'autoplay=1',
      'mute=1',
      'controls=0',
      'loop=1',
      'playlist=' + encodeURIComponent(id),
      'playsinline=1',
      'modestbranding=1',
      'rel=0',
      'showinfo=0',
      'disablekb=1',
      'fs=0'
    ].join('&');

    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?' + params;
    frame.title = '';
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('tabindex', '-1');
    frame.allow = 'autoplay; encrypted-media; picture-in-picture';
    frame.setAttribute('frameborder', '0');

    frame.addEventListener('load', function () {
      holder.classList.add('is-playing');
    });

    holder.appendChild(frame);
  }

  function init() {
    if (!shouldLoad()) return;
    var holders = document.querySelectorAll('.mx-hero__video');
    if (!holders.length) return;

    // Only start the embed once the hero is actually in view.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            build(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px' });
      holders.forEach(function (h) { io.observe(h); });
    } else {
      holders.forEach(build);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
